import React from "react";
import wabobaLogo from "assets/waboba-logo-color.png";

export const WisLogo = () => (
  <div className="flex items-center space-x-1 text-sm">
    <img src={wabobaLogo} className="w-4 scale-90" />
    <div className="font-semibold text-gray-100">WIS</div>
  </div>
);

function Icon({ icon, size, color, className = "", style }) {
  let styles = {
    fill: "currentcolor",
    verticalAlign: "middle",
    width: size ? size : 20, // CSS instead of the width attr to support non-pixel units
    height: size, // Prevents scaling issue in IE
    ...style,
  };
  if (color) styles.color = color;
  return (
    <svg
      className={`${className} inline-block`}
      width={size ? size : 20}
      height={size ? size : 20}
      viewBox="0 0 20 20"
      preserveAspectRatio="xMidYMid meet"
      fit="true"
      style={styles}
    >
      {renderGraphic(icon)}
    </svg>
  );
}

export default Icon;

function renderGraphic(icon) {
  switch (icon) {
    case "infomation":
      return (
        <path d="M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 Z M9,11 L9,10.5 L9,9 L11,9 L11,15 L9,15 L9,11 Z M9,5 L11,5 L11,7 L9,7 L9,5 Z"></path>
      );
    case "code":
      return (
        <path d="M0.707106781,10.7071068 L-2.00988464e-13,10 L5.48528137,4.51471863 L6.89949494,5.92893219 L2.82842712,10 L6.89949494,14.0710678 L5.48528137,15.4852814 L0.707106781,10.7071068 Z M19.2928932,10.7071068 L20,10 L14.5147186,4.51471863 L13.1005051,5.92893219 L17.1715729,10 L13.1005051,14.0710678 L14.5147186,15.4852814 L19.2928932,10.7071068 Z"></path>
      );
    case "view-list":
      return (
        <path d="M1,4 L3,4 L3,6 L1,6 L1,4 Z M5,4 L19,4 L19,6 L5,6 L5,4 Z M1,9 L3,9 L3,11 L1,11 L1,9 Z M5,9 L19,9 L19,11 L5,11 L5,9 Z M1,14 L3,14 L3,16 L1,16 L1,14 Z M5,14 L19,14 L19,16 L5,16 L5,14 Z"></path>
      );
    case "shield":
      return (
        <path d="M19,10.9999798 C19,13.2091299 17.4323196,15.8709335 15.5074835,16.940287 L10,20 L4.49251651,16.940287 C2.5636529,15.8686961 1,13.2055487 1,10.9999798 L1,3 C4.3761817,3 7.49184447,1.88458585 9.99858329,0.00216256114 C12.5058076,1.88587336 15.6225461,3.00212826 19,3.00212826 L19,10.9999798 Z M10,12.083735 L7.07502008,14.1191153 L8.1069132,10.708327 L5.26728307,8.55547283 L8.83000801,8.48286996 L10,5.11695271 L11.169992,8.48286996 L14.7327169,8.55547283 L11.8930868,10.708327 L12.9249799,14.1191153 L10,12.083735 Z"></path>
      );
    case "reload":
      return (
        <path d="M14.6568542,15.6568542 C13.209139,17.1045695 11.209139,18 9,18 C4.581722,18 1,14.418278 1,10 C1,5.581722 4.581722,2 9,2 C13.418278,2 17,5.581722 17,10 L15,10 C15,6.6862915 12.3137085,4 9,4 C5.6862915,4 3,6.6862915 3,10 C3,13.3137085 5.6862915,16 9,16 C10.6568542,16 12.1568542,15.3284271 13.2426407,14.2426407 L14.6568542,15.6568542 L14.6568542,15.6568542 Z M12,10 L20,10 L16,14 L12,10 L12,10 Z"></path>
      );
    case "swap":
      return (
        <path d="M9 6a4 4 0 1 1 8 0v8h3l-4 4-4-4h3V6a2 2 0 0 0-2-2 2 2 0 0 0-2 2v8a4 4 0 1 1-8 0V6H0l4-4 4 4H5v8a2 2 0 0 0 2 2 2 2 0 0 0 2-2V6z"></path>
      );
    case "more":
      return (
        <path d="M4,12 C5.1045695,12 6,11.1045695 6,10 C6,8.8954305 5.1045695,8 4,8 C2.8954305,8 2,8.8954305 2,10 C2,11.1045695 2.8954305,12 4,12 Z M10,12 C11.1045695,12 12,11.1045695 12,10 C12,8.8954305 11.1045695,8 10,8 C8.8954305,8 8,8.8954305 8,10 C8,11.1045695 8.8954305,12 10,12 Z M16,12 C17.1045695,12 18,11.1045695 18,10 C18,8.8954305 17.1045695,8 16,8 C14.8954305,8 14,8.8954305 14,10 C14,11.1045695 14.8954305,12 16,12 Z" />
      );
    case "block":
      return (
        <path d="M0 10a10 10 0 1 1 20 0 10 10 0 0 1-20 0zm16.32-4.9L5.09 16.31A8 8 0 0 0 16.32 5.09zm-1.41-1.42A8 8 0 0 0 3.68 14.91L14.91 3.68z" />
      );
    case "paste":
      return (
        <path d="M10.5029699,20 L1.99406028,20 C0.892771196,20 0,19.1054862 0,18.0059397 L0,5.99406028 C0,4.8927712 0.894513756,4 1.99406028,4 L3,4 L3,3 L5.02716314,2.59456737 C5.2250936,1.12946324 6.48064666,0 8,0 C9.51935334,0 10.7749064,1.12946324 10.9728369,2.59456737 L13,3 L13,4 L14.0059397,4 C15.1072288,4 16,4.89451376 16,5.99406028 L16,7 L14,7 L14,6 L13,6 L13,7 L3,7 L3,6 L2,6 L2,18 L7,18 L7,20 L10.5029699,20 L10.5029699,20 Z M8,4 C8.55228475,4 9,3.55228475 9,3 C9,2.44771525 8.55228475,2 8,2 C7.44771525,2 7,2.44771525 7,3 C7,3.55228475 7.44771525,4 8,4 L8,4 Z M10.0058587,8 L17.9941413,8 C19.1019465,8 20,8.89706013 20,10.0058587 L20,17.9941413 C20,19.1019465 19.1029399,20 17.9941413,20 L10.0058587,20 C8.89805351,20 8,19.1029399 8,17.9941413 L8,10.0058587 C8,8.89805351 8.89706013,8 10.0058587,8 L10.0058587,8 Z M10,10 L18,10 L18,18 L10,18 L10,10 L10,10 Z" />
      );
    case "format-text-size":
      return (
        <path
          d="M16,9 L20,9 L20,7 L10,7 L10,9 L14,9 L14,17 L16,17 L16,9 Z M8,5 L15,5 L15,3 L0,3 L0,5 L6,5 L6,17 L8,17 L8,5 Z"
          id="Combined-Shape"
        />
      );
    case "beverage":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path
            d="M9,18 L9,11 L0,2 L0,0 L20,0 L20,2 L11,11 L11,18 L16,19 L16,20 L4,20 L4,19 L9,18 Z M11,8 C12.1045695,8 13,7.1045695 13,6 C13,4.8954305 12.1045695,4 11,4 C9.8954305,4 9,4.8954305 9,6 C9,7.1045695 9.8954305,8 11,8 Z"
            id="Combined-Shape"
          />
        </g>
      );
    case "color-palette":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path
            d="M9,20 L18.0092049,20 C19.1017876,20 20,19.1054196 20,18.0018986 L20,13.9981014 C20,12.8867064 19.1086907,12 18.0092049,12 L15.0710678,12 L9.01026535,18.0608025 C9.00998975,18.139716 9.00652788,18.217877 9,18.2951708 L9,20 Z M9,16.6568542 L16.7344309,8.92242337 C17.5070036,8.14985069 17.5095717,6.88215473 16.7292646,6.10184761 L13.8981524,3.27073539 C13.1122774,2.48486045 11.8550305,2.48811526 11.0775766,3.26556912 L9,5.34314575 L9,16.6568542 Z M0,1.99079514 C0,0.891309342 0.886706352,0 1.99810135,0 L6.00189865,0 C7.10541955,0 8,0.898212381 8,1.99079514 L8,18.0092049 C8,19.1086907 7.11329365,20 6.00189865,20 L1.99810135,20 C0.894580447,20 0,19.1017876 0,18.0092049 L0,1.99079514 Z M4,17 C4.55228475,17 5,16.5522847 5,16 C5,15.4477153 4.55228475,15 4,15 C3.44771525,15 3,15.4477153 3,16 C3,16.5522847 3.44771525,17 4,17 Z"
            id="Combined-Shape"
          />
        </g>
      );
    case "thumbs-up":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path
            d="M11.0010436,0 C9.89589787,0 9.00000024,0.886706352 9.0000002,1.99810135 L9,8 L1.9973917,8 C0.894262725,8 0,8.88772964 0,10 L0,12 L2.29663334,18.1243554 C2.68509206,19.1602453 3.90195042,20 5.00853025,20 L12.9914698,20 C14.1007504,20 15,19.1125667 15,18.000385 L15,10 L12,3 L12,0 L11.0010436,0 L11.0010436,0 Z M17,10 L20,10 L20,20 L17,20 L17,10 L17,10 Z"
            id="Fill-97"
          />
        </g>
      );
    case "stand-by":
      return (
        <path d="M4.16 4.16l1.42 1.42A6.99 6.99 0 0 0 10 18a7 7 0 0 0 4.42-12.42l1.42-1.42a9 9 0 1 1-11.69 0zM9 0h2v8H9V0z" />
      );
    case "qc":
      return (
        <path
          fillRule="evenodd"
          d="M14,14 L18,14 L18,2 L2,2 L2,14 L6,14 L6,14.0020869 C6,15.1017394 6.89458045,16 7.99810135,16 L12.0018986,16 C13.1132936,16 14,15.1055038 14,14.0020869 L14,14 Z M0,1.99079514 C0,0.891309342 0.898212381,0 1.99079514,0 L18.0092049,0 C19.1086907,0 20,0.898212381 20,1.99079514 L20,18.0092049 C20,19.1086907 19.1017876,20 18.0092049,20 L1.99079514,20 C0.891309342,20 0,19.1017876 0,18.0092049 L0,1.99079514 Z M5,9 L7,7 L9,9 L13,5 L15,7 L9,13 L5,9 Z"
        />
      );
    case "money":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <g>
            <path d="M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z M11,15 L11,17 L9,17 L9,15 L6,15 L6,13 L10.5838882,13 L11.9970707,13 C12.5621186,13 13,12.5522847 13,12 C13,11.4438648 12.5509732,11 11.9970707,11 L10.5838882,11 L8,11 C6.34314575,11 5,9.65685425 5,8 C5,6.34314575 6.34314575,5 8,5 L9,5 L9,3 L11,3 L11,5 L14,5 L14,7 L9.41464715,7 L7.99077797,7 C7.45097518,7 7,7.44771525 7,8 C7,8.55613518 7.44358641,9 7.99077797,9 L9.41464715,9 L12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 L11,15 Z" />
          </g>
        </g>
      );

    case "search":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <g>
            <path
              d="M12.9056439,14.3198574 C11.5509601,15.3729184 9.84871145,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,9.84871145 15.3729184,11.5509601 14.3198574,12.9056439 L19.6568542,18.2426407 L18.2426407,19.6568542 L12.9056439,14.3198574 Z M8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      );

    case "dashboard":
      return (
        <path
          fillRule="evenodd"
          d="M3,19 L7,17 L13,17 L17,19 L17,20 L3,20 L3,19 Z M0,2.00010618 C0,0.895478039 0.898212381,0 1.99079514,0 L18.0092049,0 C19.1086907,0 20,0.890058413 20,2.00010618 L20,14.9998938 C20,16.104522 19.1017876,17 18.0092049,17 L1.99079514,17 C0.891309342,17 0,16.1099416 0,14.9998938 L0,2.00010618 Z M2,2 L18,2 L18,13 L2,13 L2,2 Z"
        />
      );
    case "copy":
      return (
        <path
          fillRule="evenodd"
          d="M0,8.00585866 C0,6.89805351 0.897060126,6 2.00585866,6 L11.9941413,6 C13.1019465,6 14,6.89706013 14,8.00585866 L14,17.9941413 C14,19.1019465 13.1029399,20 11.9941413,20 L2.00585866,20 C0.898053512,20 0,19.1029399 0,17.9941413 L0,8.00585866 L0,8.00585866 Z M6,8 L2,8 L2,18 L12,18 L12,14 L15,14 L15,12 L18,12 L18,2 L8,2 L8,5 L6,5 L6,8 L12,8 L12,14 L17.9941413,14 C19.1029399,14 20,13.1019465 20,11.9941413 L20,2.00585866 C20,0.897060126 19.1019465,0 17.9941413,0 L8.00585866,0 C6.89706013,0 6,0.898053512 6,2.00585866 L6,8 Z"
        />
      );
    case "bus":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <g>
            <path
              d="M13,18 L7,18 L7,19.0010434 C7,19.5527519 6.55733967,20 6.00104344,20 L4.99895656,20 C4.44724809,20 4,19.5573397 4,19.0010434 L4,18 L3.99406028,18 C2.8927712,18 2,17.1073772 2,16.0049107 L2,1.99508929 C2,0.893231902 2.89451376,0 3.99406028,0 L16.0059397,0 C17.1072288,0 18,0.892622799 18,1.99508929 L18,16.0049107 C18,17.1067681 17.1054862,18 16.0059397,18 L16,18 L16,19.0010434 C16,19.5527519 15.5573397,20 15.0010434,20 L13.9989566,20 C13.4472481,20 13,19.5573397 13,19.0010434 L13,18 Z M4,5 L9,5 L9,11 L4,11 L4,5 Z M11,5 L16,5 L16,11 L11,11 L11,5 Z M5,2 L15,2 L15,3 L5,3 L5,2 Z M5.5,16 C6.32842712,16 7,15.3284271 7,14.5 C7,13.6715729 6.32842712,13 5.5,13 C4.67157288,13 4,13.6715729 4,14.5 C4,15.3284271 4.67157288,16 5.5,16 Z M14.5,16 C15.3284271,16 16,15.3284271 16,14.5 C16,13.6715729 15.3284271,13 14.5,13 C13.6715729,13 13,13.6715729 13,14.5 C13,15.3284271 13.6715729,16 14.5,16 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      );
    case "hand-stop":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path
            d="M17,15.9998075 C17,18.2090528 15.2126701,20 13.0068977,20 L6.99310226,20 C4.78777278,20 3,18.2122004 3,15.990237 L3,11 L3,3.99539757 C3,3.44565467 3.44386482,3 4,3 C4.55228475,3 5,3.4556644 5,3.99539757 L5,10 L6,10 L6,1.9955775 C6,1.44573523 6.44386482,1 7,1 C7.55228475,1 8,1.44483697 8,1.9955775 L8,10 L9,10 L9,1.00247329 C9,0.448822582 9.44386482,0 10,0 C10.5522847,0 11,0.455760956 11,1.00247329 L11,10 L12,10 L12,1.9955775 C12,1.44573523 12.4438648,1 13,1 C13.5522847,1 14,1.44483697 14,1.9955775 L14,11 L14,15 L15,15 L15,8.99703014 C15,8.4463856 15.4438648,8 16,8 L17,8 L17,15.4999037 L17,15.9998075 Z"
            id="Combined-Shape"
          />
        </g>
      );
    case "flag":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <polygon points="7.66666667 12 2 12 2 20 0 20 0 0 1 0 12 0 12.3333333 2 20 2 17 8 20 14 8 14 7.66666667 12" />
        </g>
      );
    case "ship":
      return (
        <path d="M8,1.87770689 L8,0 L10,0 L10,16 L20,16 L16,20 L2,20 L0,16 L8,16 L8,16 L8,14 L0,14 L0,13.7361129 C3.75637865,10.7248872 6.5877343,6.60739627 8,1.87770689 L8,1.87770689 Z M19.969258,14 L10,14 L10,13.6355902 C11.2636946,11.7349777 12,9.4534755 12,7 C12,4.5465245 11.2636946,2.26502235 10,0.364409754 L10,0.163034095 C15.570379,2.41786621 19.5819057,7.71862888 19.969258,14 L19.969258,14 L19.969258,14 Z" />
      );
    case "waboba-logo":
      return (
        <path
          d="M17,1.5c-3,2.9-7,7.8-9.1,13.8c-0.2,0.6-0.5,1.6-0.6,1.7c0,0.1-0.3-1-0.3-1.5c-0.1-1.1,0.2-2.1,0.7-2.9
    c0.4-0.6,1.4-1.3,0-1.4c-1.9-0.1-4.1,2.1-4.3,2.4C3.2,13.7,3.1,14,3,14s0-0.3,0-0.5C3.3,10.7,4.6,7,4.3,6.8s-1.7,1.5-1.9,2
    c-0.2,0.4-0.9,3.9-1,6.2c0,0.6-0.2,1.9,0.4,2c0.4,0,0.8-0.8,1-1.1c1.8-2.7,3.4-3.4,3.4-3.3c0,0.1-0.1-0.1-0.3,0.9
    c-0.3,1.8,0,4,0.7,5.4C6.9,19.2,7.5,20.1,8,20c0.4-0.1,0.5-1,0.6-1.3c0.3-1.7,0.7-3.2,1.2-4.5c1.4-3.7,3.2-6.9,5.4-9.9
    c0.7-0.9,1.4-1.8,2.1-2.6C17.7,1.1,18.6,0,18.6,0C18.5,0,17.5,1,17,1.5"
        />
      );
    case "wis-logo":
      return (
        <g>
          <path
            d="M103,4.4C87.7,18.6,72.5,35.8,61.3,52.7c-11.5,17.5-18.9,33.8-22,48.6c-1.6-3.1-2.4-6.6-2.5-10.1
	c0-1.9,0.2-3.8,0.6-5.6c1-5,4.7-9.7,6.5-12l0.4-0.6c0.3-0.4,0.7-0.8,0.9-1.3l0.2-0.5c0-0.1,0-0.2,0-0.3c0-0.4-0.2-1.2-1.3-1.7
	c-3.5-1.6-18.8,1.3-29.2,15.9c0-0.2,0-0.5,0-0.7c0-9.8,5.5-31.8,7.2-38.8c0.2-0.7,0.4-1.5,0.5-2.3c0-0.1,0-0.2-0.1-0.2L22.3,43
	l-0.2,0.1c-3.9,3.4-7.4,7.3-10.2,11.6L11.8,55c-4,13.9-7.8,42.2-5.1,45.4c0.5,0.5,1.3,0.8,2,0.7c0.8-0.1,1.5-0.6,1.9-1.3
	c11.5-18.6,19.9-23.4,21-23.2v0.1c-1.1,2.7-1.7,5.7-1.5,8.6c0,11.2,5,26.6,9.6,31c1.4,1.4,2.6,1.9,3.6,1.6c2-0.6,2.6-4.4,3.4-8.9
	c0.3-1.6,0.5-3.2,0.9-4.7c7.1-30.7,25.2-63.5,54-97.6C101.5,6.7,103,4.4,103,4.4"
          />
          <path d="M69.8,104.4l-8.7-23.1h4l5.2,14.9l6-15.3h0.3l6.1,15.3L88,81.3h4l-8.6,23.1H83l-6.4-15.6l-6.4,15.6H69.8z" />
          <path d="M94.9,103.8V81.3h3.8v22.4L94.9,103.8z" />
          <path
            d="M106.1,103.1c-1.5-0.8-2.8-2-3.8-3.4l2.5-2c1.3,2.2,3.7,3.5,6.2,3.5c1.2,0.1,2.4-0.2,3.3-0.9
	c0.8-0.5,1.2-1.4,1.2-2.3s-0.4-1.8-1.2-2.3c-1.1-0.7-2.3-1.3-3.5-1.8s-2.4-1-3.6-1.6c-0.9-0.5-1.7-1.2-2.3-2c-0.7-1-1-2.1-1-3.3
	c-0.1-1.7,0.7-3.4,2-4.4c1.5-1.2,3.4-1.7,5.2-1.6c1.5,0,2.9,0.3,4.3,0.9c1.2,0.6,2.2,1.4,3,2.5l-2.4,2c-1.1-1.5-2.9-2.3-4.8-2.3
	c-0.9-0.1-1.9,0.2-2.7,0.7c-1.1,0.9-1.3,2.4-0.4,3.5l0,0c0.4,0.5,0.9,0.8,1.5,1.1c0.9,0.4,1.8,0.8,2.7,1.2c1.2,0.5,2.5,1,3.7,1.6
	c0.9,0.5,1.8,1.2,2.4,2.1c0.7,1,1,2.1,1,3.3c0,1.3-0.3,2.5-1,3.6c-0.8,1-1.8,1.9-3,2.3c-1.4,0.6-2.8,0.8-4.3,0.8
	C109.4,104.3,107.6,103.9,106.1,103.1z"
          />
        </g>
      );
    case "attachment":
      return (
        <g>
          <path d="M15,3 L7,3 C3.13400675,3 0,6.13400675 0,10 C0,13.8659932 3.13400675,17 7,17 L15,17 L15,15 L9.44949137,15 L7,15 C4.23857625,15 2,12.7614237 2,10 C2,7.23857625 4.23857625,5 7,5 L9.44949137,5 L12.9998169,5 L15,5 C16.6568542,5 18,6.34314575 18,8 C18,9.65685425 16.6568542,11 15,11 L12.9998169,11 L8.41464715,11 L7,11 C6.44771525,11 6,10.5522847 6,10 C6,9.44771525 6.44771525,9 7,9 L8.41464715,9 L15,9 L15,7 L7,7 C5.34314575,7 4,8.34314575 4,10 C4,11.6568542 5.34314575,13 7,13 L15,13 C17.7614237,13 20,10.7614237 20,8 C20,5.23857625 17.7614237,3 15,3 Z" />
        </g>
      );
    case "eye-open":
      return (
        <g>
          <path
            d="M19.8,9.5C19.9,9.7,20,10,20,10.3s-0.1,0.6-0.2,0.8c-1,1.7-2.3,3-4.1,4c-1.7,1-3.6,1.5-5.7,1.5c-2.1,0-4-0.5-5.7-1.5
        c-1.7-1-3.1-2.3-4.1-4C0.1,10.9,0,10.6,0,10.3s0.1-0.6,0.2-0.8c1-1.7,2.4-3,4.1-4C6,4.4,7.9,3.9,10,3.9c2.1,0,4,0.5,5.7,1.5
        C17.4,6.4,18.8,7.8,19.8,9.5z M10,15c1.8,0,3.4-0.4,4.8-1.3c1.5-0.9,2.6-2,3.5-3.4c-0.5-0.9-1.2-1.7-2-2.3
        c-0.8-0.7-1.7-1.2-2.6-1.6c0.6,0.9,1,1.8,1,2.9c0,0.9-0.2,1.6-0.6,2.4c-0.4,0.7-1,1.3-1.7,1.7c-0.7,0.4-1.5,0.6-2.4,0.6
        s-1.6-0.2-2.4-0.6c-0.7-0.4-1.3-1-1.7-1.7C5.5,10.8,5.3,10,5.3,9.2c0-0.8,0.2-1.5,0.6-2.2c0,0.5,0.2,1,0.6,1.4
        c0.4,0.4,0.8,0.6,1.4,0.6s1-0.2,1.4-0.6C9.5,8,9.7,7.5,9.7,7S9.5,6,9.2,5.6c-1.6,0.1-3,0.6-4.3,1.5C3.5,7.9,2.5,9,1.7,10.3
        c0.9,1.4,2,2.6,3.5,3.4C6.6,14.6,8.2,15,10,15z"
          />
        </g>
      );
    case "eye-closed":
      return (
        <g>
          <path
            d="M10,15h0.3l1.1,1.6c-0.5,0-0.9,0.1-1.4,0.1c-2.1,0-4-0.5-5.7-1.5c-1.7-1-3.1-2.3-4.1-4C0.1,10.9,0,10.6,0,10.3
        s0.1-0.6,0.2-0.8C1.1,8,2.3,6.7,3.8,5.8l0.9,1.4C3.4,7.9,2.4,9,1.7,10.3c0.9,1.4,2,2.6,3.5,3.4C6.6,14.6,8.2,15,10,15z M19.8,11.1
        c0.2-0.3,0.2-0.5,0.2-0.8s-0.1-0.6-0.2-0.8c-1-1.7-2.3-3-4.1-4c-1.7-1-3.6-1.5-5.7-1.5c-1.1,0-2.1,0.1-3.1,0.4L4.9,1.6
        c0-0.1-0.1-0.2-0.2-0.2s-0.2,0-0.3,0.1L3.6,2C3.6,2.1,3.5,2.2,3.5,2.3c0,0.1,0,0.2,0.1,0.3L15.1,19c0,0.1,0.1,0.2,0.2,0.2
        c0.1,0,0.2,0,0.3-0.1l0.7-0.5c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0-0.2-0.1-0.3l-1.7-2.4c1-0.5,2-1.1,2.8-1.9
        C18.5,13,19.2,12.1,19.8,11.1z M9.5,13.9L5.4,8.1C5.2,9,5.2,9.9,5.5,10.7c0.3,0.9,0.8,1.6,1.5,2.2C7.7,13.5,8.6,13.8,9.5,13.9z
         M18.3,10.3c-0.5,0.9-1.2,1.7-1.9,2.3c-0.8,0.7-1.6,1.2-2.6,1.6l-0.9-1.3c0.9-0.7,1.5-1.6,1.7-2.8C14.9,9,14.7,8,14.2,7
        c0,0.5-0.2,1-0.6,1.4c-0.4,0.4-0.8,0.6-1.4,0.6s-1-0.2-1.4-0.6C10.5,8,10.3,7.5,10.3,7s0.2-1,0.6-1.4c1.6,0.1,3,0.6,4.3,1.5
        C16.5,7.9,17.5,9,18.3,10.3z"
          />
        </g>
      );
    case "lock-open":
      return (
        <g fillRule="evenodd">
          <path d="M11,14.7324356 C11.5978014,14.3866262 12,13.7402824 12,13 C12,11.8954305 11.1045695,11 10,11 C8.8954305,11 8,11.8954305 8,13 C8,13.7402824 8.40219863,14.3866262 9,14.7324356 L9,17 L11,17 L11,14.7324356 Z M13,6 C13,4.34314575 11.6568542,3 10,3 C8.34314575,3 7,4.34314575 7,6 L7,8 L13,8 L13,6 Z M4,8 L4,6 C4,2.6862915 6.6862915,0 10,0 C13.3137085,0 16,2.6862915 16,6 L13,6 L13,8 L17.0049107,8 C18.1067681,8 19,8.90195036 19,10.0085302 L19,17.9914698 C19,19.1007504 18.1073772,20 17.0049107,20 L2.99508929,20 C1.8932319,20 1,19.0980496 1,17.9914698 L1,10.0085302 C1,8.8992496 1.8926228,8 2.99508929,8 L4,8 Z" />
        </g>
      );
    case "lock-closed":
      return (
        <g>
          <path d="M11,14.7324356 C11.5978014,14.3866262 12,13.7402824 12,13 C12,11.8954305 11.1045695,11 10,11 C8.8954305,11 8,11.8954305 8,13 C8,13.7402824 8.40219863,14.3866262 9,14.7324356 L9,17 L11,17 L11,14.7324356 Z M13,6 C13,4.34314575 11.6568542,3 10,3 C8.34314575,3 7,4.34314575 7,6 L7,8 L13,8 L13,6 Z M4,8 L4,6 C4,2.6862915 6.6862915,0 10,0 C13.3137085,0 16,2.6862915 16,6 L16,8 L17.0049107,8 C18.1067681,8 19,8.90195036 19,10.0085302 L19,17.9914698 C19,19.1007504 18.1073772,20 17.0049107,20 L2.99508929,20 C1.8932319,20 1,19.0980496 1,17.9914698 L1,10.0085302 C1,8.8992496 1.8926228,8 2.99508929,8 L4,8 Z" />
        </g>
      );
    case "open-issue":
      return (
        <g>
          <path
            fillRule="evenodd"
            d="M7 2.3c3.14 0 5.7 2.56 5.7 5.7s-2.56 5.7-5.7 5.7A5.71 5.71 0 0 1 1.3 8c0-3.14 2.56-5.7 5.7-5.7zM7 1C3.14 1 0 4.14 0 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm1 3H6v5h2V4zm0 6H6v2h2v-2z"
          />
        </g>
      );
    case "graph":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M1,10 L4,10 L4,20 L1,20 L1,10 Z M6,0 L9,0 L9,20 L6,20 L6,0 Z M11,8 L14,8 L14,20 L11,20 L11,8 Z M16,4 L19,4 L19,20 L16,20 L16,4 Z" />
        </g>
      );
    case "time":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <g id="icon-shape">
            <path
              d="M9,8.5 L9,4 L11,4 L11,9.58578644 L14.9497475,13.5355339 L13.5355339,14.9497475 L9,10.4142136 L9,8.5 Z M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z M10,18 C14.418278,18 18,14.418278 18,10 C18,5.581722 14.418278,2 10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      );
    case "timer":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M14.9056439,5.68014258 C13.7991209,4.81998894 12.4607085,4.24404153 11,4.06189375 L11,2 L9,2 L9,4.06189375 C5.05368842,4.55399184 2,7.92038235 2,12 C2,16.418278 5.581722,20 10,20 C14.418278,20 18,16.418278 18,12 C18,10.1512885 17.3729184,8.44903985 16.3198574,7.09435615 L17.7781746,5.63603897 L16.363961,4.22182541 L14.9056439,5.68014258 Z M10,18 C13.3137085,18 16,15.3137085 16,12 C16,8.6862915 13.3137085,6 10,6 C6.6862915,6 4,8.6862915 4,12 C4,15.3137085 6.6862915,18 10,18 Z M7,0 L13,0 L13,2 L7,2 L7,0 Z M12.1213203,8.46446609 L13.5355339,9.87867966 L10,13.4142136 L8.58578644,12 L12.1213203,8.46446609 Z" />
        </g>
      );
    case "closed-issue":
      return (
        <g>
          <path
            fillRule="evenodd"
            d="M7 10h2v2H7v-2zm2-6H7v5h2V4zm1.5 1.5l-1 1L12 9l4-4.5-1-1L12 7l-1.5-1.5zM8 13.7A5.71 5.71 0 0 1 2.3 8c0-3.14 2.56-5.7 5.7-5.7 1.83 0 3.45.88 4.5 2.2l.92-.92A6.947 6.947 0 0 0 8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7l-1.52 1.52c-.66 2.41-2.86 4.19-5.48 4.19v-.01z"
          />
        </g>
      );
    case "calendar":
      return (
        <path
          fillRule="evenodd"
          d="M1,3.99508929 C1,2.8932319 1.8926228,2 2.99508929,2 L17.0049107,2 C18.1067681,2 19,2.8926228 19,3.99508929 L19,18.0049107 C19,19.1067681 18.1073772,20 17.0049107,20 L2.99508929,20 C1.8932319,20 1,19.1073772 1,18.0049107 L1,3.99508929 Z M3,6 L17,6 L17,18 L3,18 L3,6 Z M5,0 L7,0 L7,2 L5,2 L5,0 Z M13,0 L15,0 L15,2 L13,2 L13,0 Z M5,9 L7,9 L7,11 L5,11 L5,9 Z M5,13 L7,13 L7,15 L5,15 L5,13 Z M9,9 L11,9 L11,11 L9,11 L9,9 Z M9,13 L11,13 L11,15 L9,15 L9,13 Z M13,9 L15,9 L15,11 L13,11 L13,9 Z M13,13 L15,13 L15,15 L13,15 L13,13 Z"
        />
      );
    case "menu":
      return (
        <g>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
        </g>
      );
    case "exclamation":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 Z M9,5 L11,5 L11,11 L9,11 L9,5 Z M9,13 L11,13 L11,15 L9,15 L9,13 Z" />
        </g>
      );
    case "wechat":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <circle cx="9.7" cy="7.2" r="0.7" />
          <circle cx="6.4" cy="7.2" r="0.7" />
          <circle cx="14.2" cy="10.6" r="0.6" />
          <circle cx="11.4" cy="10.6" r="0.6" />
          <path
            d="M10,0C4.5,0,0,4.5,0,10c0,5.5,4.5,10,10,10c5.5,0,10-4.5,10-10C20,4.5,15.5,0,10,0z M8.4,12.3c-0.5,0-0.9-0.1-1.4-0.2
        l-0.1,0c-0.1,0-0.2,0-0.2,0.1l-0.9,0.5l-0.1,0c-0.1,0-0.1-0.1-0.1-0.1l0-0.1l0.2-0.7l0-0.1c0-0.1,0-0.2-0.1-0.2
        c-0.9-0.6-1.5-1.6-1.5-2.7c0-1.9,1.9-3.5,4.2-3.5c2.1,0,3.8,1.3,4.2,3l-0.2,0c-2.1,0-3.8,1.4-3.8,3.2c0,0.3,0,0.6,0.1,0.9L8.4,12.3
        z M14.6,13.7c-0.1,0-0.1,0.1-0.1,0.2l0,0.1l0.2,0.6l0,0.1c0,0.1-0.1,0.1-0.1,0.1l-0.1,0l-0.8-0.4c-0.1,0-0.1-0.1-0.2-0.1l-0.1,0
        c-0.4,0.1-0.7,0.2-1.1,0.2c-1.9,0-3.5-1.3-3.5-2.9c0-1.6,1.6-2.9,3.5-2.9c1.9,0,3.5,1.3,3.5,2.9C15.8,12.3,15.4,13.1,14.6,13.7z"
          />
        </g>
      );
    case "alipay":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path
            d="M20,10c0-1.5-0.3-2.9-0.9-4.2c-1-2.2-2.7-3.9-4.9-4.9C12.9,0.3,11.5,0,10,0S7.1,0.3,5.8,0.9c-2.2,1-3.9,2.7-4.9,4.9
        C0.3,7.1,0,8.5,0,10s0.3,2.9,0.9,4.2c1,2.2,2.7,3.9,4.9,4.9C7.1,19.7,8.5,20,10,20s2.9-0.3,4.2-0.9c1.5-0.7,2.8-1.8,3.8-3.1
        c-1.7-0.9-3.9-1.9-6-2.8c-1.3,1.8-3.5,3.3-6.1,3.3c-2.9,0-3.8-1.9-4-3.1C1.8,11.8,2.6,10,6,10c1.4,0,3.3,0.4,5.2,1
        c0.5-0.9,0.9-2.1,1-2.5c-0.7,0-7.3,0-7.3,0v-1h4v-1H4.5v-1H9v-2l2,0v2h4.5v1H11v1h3.5c0,0-0.5,2.3-1.6,4.1c2,0.7,4.1,1.2,6.1,1.9
        l0.2,0.1C19.7,12.5,20,11.3,20,10z"
          />
          <path d="M2.6,13.2c0,0.8,0.4,2.2,2.9,2.2c2.1,0,3.8-1.6,4.8-3c-1.8-0.8-3.5-1.3-4.5-1.3C3.1,11.1,2.6,12.5,2.6,13.2z" />
        </g>
      );
    case "question":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M14,7 C14,7.81404368 13.5749107,8.83930284 12.9961487,9.4180649 L11.4180649,10.9961487 C11.2143227,11.1998909 11,11.7148676 11,12 L11,13 L9,13 L9,12 C9,11.1832235 9.42588582,10.1599006 10.0038513,9.5819351 L11.5819351,8.00385134 C11.7857992,7.79998728 12,7.28336316 12,7 C12,5.8954305 11.1045695,5 10,5 C8.8954305,5 8,5.8954305 8,7 L6,7 C6,4.790861 7.790861,3 10,3 C12.209139,3 14,4.790861 14,7 Z M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z M9,15 L11,15 L11,17 L9,17 L9,15 Z" />
        </g>
      );
    case "prepaid":
    case "cash":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z M11,15 L11,17 L9,17 L9,15 L6,15 L6,13 L10.5838882,13 L11.9970707,13 C12.5621186,13 13,12.5522847 13,12 C13,11.4438648 12.5509732,11 11.9970707,11 L10.5838882,11 L8,11 C6.34314575,11 5,9.65685425 5,8 C5,6.34314575 6.34314575,5 8,5 L9,5 L9,3 L11,3 L11,5 L14,5 L14,7 L9.41464715,7 L7.99077797,7 C7.45097518,7 7,7.44771525 7,8 C7,8.55613518 7.44358641,9 7.99077797,9 L9.41464715,9 L12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 L11,15 Z" />
        </g>
      );
    case "up":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <polygon points="10.7071068 7.05025253 10 6.34314575 4.34314575 12 5.75735931 13.4142136 10 9.17157288 14.2426407 13.4142136 15.6568542 12" />
        </g>
      );
    case "down":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <polygon points="9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8" />
        </g>
      );
    case "left":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <polygon points="7.05025253 9.29289322 6.34314575 10 12 15.6568542 13.4142136 14.2426407 9.17157288 10 13.4142136 5.75735931 12 4.34314575" />
        </g>
      );
    case "right":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <polygon points="12.9497475 10.7071068 13.6568542 10 8 4.34314575 6.58578644 5.75735931 10.8284271 10 6.58578644 14.2426407 8 15.6568542 12.9497475 10.7071068" />
        </g>
      );
    case "archive":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M0,2 C0,0.8954305 0.898212381,0 1.99079514,0 L18.0092049,0 C19.1086907,0 20,0.887729645 20,2 L20,4 L0,4 L0,2 Z M1,5 L19,5 L19,18.0081158 C19,19.1082031 18.1073772,20 17.0049107,20 L2.99508929,20 C1.8932319,20 1,19.1066027 1,18.0081158 L1,5 Z M7,7 L13,7 L13,9 L7,9 L7,7 Z" />
        </g>
      );
    case "credit-card":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M0,3.99406028 C0,2.8927712 0.898212381,2 1.99079514,2 L18.0092049,2 C19.1086907,2 20,2.89451376 20,3.99406028 L20,16.0059397 C20,17.1072288 19.1017876,18 18.0092049,18 L1.99079514,18 C0.891309342,18 0,17.1054862 0,16.0059397 L0,3.99406028 Z M2,4 L18,4 L18,16 L2,16 L2,4 Z M2,6 L18,6 L18,10 L2,10 L2,6 Z M4,12 L8,12 L8,14 L4,14 L4,12 Z" />
        </g>
      );
    case "wrench":
    case "staff":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M9.42239525,7.09396812 C10.2387498,5.25806681 9.89409813,3.03105216 8.38844025,1.52539428 C6.93864576,0.0755997864 4.82002948,-0.297742297 3.02577331,0.40536803 L6.97422669,4.35382141 L4.14579956,7.18224853 L0.197346187,3.23379515 C-0.50576414,5.02805132 -0.132422056,7.1466676 1.31737244,8.59646209 C2.70997507,9.98906472 4.71967257,10.3884681 6.46624524,9.79467236 L16.5961941,19.9246212 L19.4246212,17.0961941 L9.42239525,7.09396812 Z" />
        </g>
      );
    case "client":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M4.99999861,5.00218626 C4.99999861,2.23955507 7.24419318,0 9.99999722,0 C12.7614202,0 14.9999958,2.22898489 14.9999958,5.00218626 L14.9999958,6.99781374 C14.9999958,9.76044493 12.7558013,12 9.99999722,12 C7.23857424,12 4.99999861,9.77101511 4.99999861,6.99781374 L4.99999861,5.00218626 Z M1.11022272e-16,16.6756439 C2.94172855,14.9739441 6.3571245,14 9.99999722,14 C13.6428699,14 17.0582659,14.9739441 20,16.6756471 L19.9999944,20 L0,20 L1.11022272e-16,16.6756439 Z" />
        </g>
      );
    case "projects":
      return (
        <path
          stroke="none"
          strokeWidth="1"
          fill="currentColor"
          fillRule="evenodd"
          d="M4,10 L12,10 L12,12 L4,12 L4,10 L4,10 Z M4,14 L12,14 L12,16 L4,16 L4,14 L4,14 Z M4,4 L12,4 L12,8 L4,8 L4,4 L4,4 Z M16,2 L16,1 L16,0 L0,0 L0,1 L0,1 L0,17.0057979 C0,18.656688 1.34320226,20 3.00012623,20 L17,20 C18.6534829,20 20,18.6601943 20,17.0074602 L20,3 L20,2 L16,2 L16,2 L16,2 Z M16,4 L16,17.0066023 C16,17.5552407 16.4438648,18 17,18 C17.5522847,18 18,17.5553691 18,16.9991283 L18,4 L16,4 L16,4 L16,4 Z M2,2 L14,2 L14,17.0057979 C14,17.3541355 14.0597981,17.6887794 14.1697239,18 L3.00748397,18 C2.44892021,18 2,17.5552407 2,17.0066023 L2,2 L2,2 L2,2 L2,2 Z"
        />
      );
    case "user":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z M6.99999861,6.00166547 C6.99999861,4.34389141 8.3465151,3 9.99999722,3 C11.6568507,3 12.9999958,4.33902013 12.9999958,6.00166547 L12.9999958,7.99833453 C12.9999958,9.65610859 11.6534793,11 9.99999722,11 C8.34314374,11 6.99999861,9.66097987 6.99999861,7.99833453 L6.99999861,6.00166547 Z M3.34715433,14.4444439 C5.37306718,13.5169611 7.62616222,13 10,13 C12.3738388,13 14.6269347,13.5169615 16.6528458,14.4444437 C15.2177146,16.5884188 12.7737035,18 10,18 C7.22629656,18 4.78228556,16.5884189 3.34715433,14.4444439 L3.34715433,14.4444439 Z" />
        </g>
      );
    case "user-square":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M0,1.99079514 C0,0.891309342 0.898212381,0 1.99079514,0 L18.0092049,0 C19.1086907,0 20,0.898212381 20,1.99079514 L20,18.0092049 C20,19.1086907 19.1017876,20 18.0092049,20 L1.99079514,20 C0.891309342,20 0,19.1017876 0,18.0092049 L0,1.99079514 Z M6.99999861,6.00166547 C6.99999861,4.34389141 8.3465151,3 9.99999722,3 C11.6568507,3 12.9999958,4.33902013 12.9999958,6.00166547 L12.9999958,7.99833453 C12.9999958,9.65610859 11.6534793,11 9.99999722,11 C8.34314374,11 6.99999861,9.66097987 6.99999861,7.99833453 L6.99999861,6.00166547 Z M18.0000045,15.1405177 C15.6466165,13.7791553 12.914299,13 10,13 C7.08570101,13 4.35338349,13.7791553 1.99999555,15.1405177 L2,18 L18,18 L18,15.1405151 L18.0000045,15.1405177 Z" />
        </g>
      );
    case "trash":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M2,2 L18,2 L18,4 L2,4 L2,2 Z M8,0 L12,0 L14,2 L6,2 L8,0 Z M3,6 L17,6 L16,20 L4,20 L3,6 Z M8,8 L9,8 L9,18 L8,18 L8,8 Z M11,8 L12,8 L12,18 L11,18 L11,8 Z" />
        </g>
      );
    case "deleted":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M2,2 L18,2 L18,4 L2,4 L2,2 Z M8,0 L12,0 L14,2 L6,2 L8,0 Z M3,6 L17,6 L16,20 L4,20 L3,6 Z M8,8 L9,8 L9,18 L8,18 L8,8 Z M11,8 L12,8 L12,18 L11,18 L11,8 Z" />
        </g>
      );
    case "show":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M19.8005808,10 C17.9798698,6.43832409 14.2746855,4 10,4 C5.72531453,4 2.02013017,6.43832409 0.199419187,10 C2.02013017,13.5616759 5.72531453,16 10,16 C14.2746855,16 17.9798698,13.5616759 19.8005808,10 Z M10,14 C12.209139,14 14,12.209139 14,10 C14,7.790861 12.209139,6 10,6 C7.790861,6 6,7.790861 6,10 C6,12.209139 7.790861,14 10,14 Z M10,12 C11.1045695,12 12,11.1045695 12,10 C12,8.8954305 11.1045695,8 10,8 C8.8954305,8 8,8.8954305 8,10 C8,11.1045695 8.8954305,12 10,12 Z" />
        </g>
      );
    case "minus-solid":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path
            d="M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z M15,9 L15,11 L5,11 L5,9 L15,9 Z"
            id="Combined-Shape-Copy"
          />
        </g>
      );
    case "delete":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M11.4142136,10 L14.2426407,7.17157288 L12.8284271,5.75735931 L10,8.58578644 L7.17157288,5.75735931 L5.75735931,7.17157288 L8.58578644,10 L5.75735931,12.8284271 L7.17157288,14.2426407 L10,11.4142136 L12.8284271,14.2426407 L14.2426407,12.8284271 L11.4142136,10 L11.4142136,10 Z M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 L2.92893219,17.0710678 Z" />
        </g>
      );
    case "close-solid":
      return (
        <g
          istroke="none"
          strokeWidth="1"
          fill="currentColor"
          fillRule="evenodd"
        >
          <g>
            <path
              d="M11.4142136,10 L14.2426407,7.17157288 L12.8284271,5.75735931 L10,8.58578644 L7.17157288,5.75735931 L5.75735931,7.17157288 L8.58578644,10 L5.75735931,12.8284271 L7.17157288,14.2426407 L10,11.4142136 L12.8284271,14.2426407 L14.2426407,12.8284271 L11.4142136,10 L11.4142136,10 Z M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 L2.92893219,17.0710678 Z"
              id="Combined-Shape-Copy"
            />
          </g>
        </g>
      );
    case "close-outline":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M11.4142136,10 L14.2426407,7.17157288 L12.8284271,5.75735931 L10,8.58578644 L7.17157288,5.75735931 L5.75735931,7.17157288 L8.58578644,10 L5.75735931,12.8284271 L7.17157288,14.2426407 L10,11.4142136 L12.8284271,14.2426407 L14.2426407,12.8284271 L11.4142136,10 L11.4142136,10 Z M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 L2.92893219,17.0710678 Z M4.34314575,15.6568542 C7.46734008,18.7810486 12.5326599,18.7810486 15.6568542,15.6568542 C18.7810486,12.5326599 18.7810486,7.46734008 15.6568542,4.34314575 C12.5326599,1.21895142 7.46734008,1.21895142 4.34314575,4.34314575 C1.21895142,7.46734008 1.21895142,12.5326599 4.34314575,15.6568542 L4.34314575,15.6568542 Z" />
        </g>
      );
    case "close":
      return (
        <polygon points="10 8.58578644 2.92893219 1.51471863 1.51471863 2.92893219 8.58578644 10 1.51471863 17.0710678 2.92893219 18.4852814 10 11.4142136 17.0710678 18.4852814 18.4852814 17.0710678 11.4142136 10 18.4852814 2.92893219 17.0710678 1.51471863 10 8.58578644" />
      );
    case "map":
      return (
        <g>
          <path d="M0 0l6 4 8-4 6 4v16l-6-4-8 4-6-4V0zm7 6v11l6-3V3L7 6z" />
        </g>
      );
    case "book":
      return (
        <g>
          <path d="M2 2c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v18l-8-4-8 4V2zm2 0v15l6-3 6 3V2H4z" />
        </g>
      );
    case "play":
      return (
        <g>
          <path d="M4 4l12 6-12 6z" />
        </g>
      );
    case "play-outline":
      return (
        <g>
          <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM7 6l8 4-8 4V6z" />
        </g>
      );
    case "tick":
      return (
        <g>
          <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
        </g>
      );
    case "pause":
      return (
        <g>
          <path d="M5 4h3v12H5V4zm7 0h3v12h-3V4z" />
        </g>
      );
    case "plane":
      return (
        <g>
          <path d="M8.4 12H2.8L1 15H0V5h1l1.8 3h5.6L6 0h2l4.8 8H18a2 2 0 1 1 0 4h-5.2L8 20H6l2.4-8z" />
        </g>
      );
    case "cog":
      return (
        <path
          d="M3.93830521,6.49683865 C3.63405147,7.02216933 3.39612833,7.5907092 3.23599205,8.19100199 L5.9747955e-16,9 L9.6487359e-16,11 L3.23599205,11.808998 C3.39612833,12.4092908 3.63405147,12.9778307 3.93830521,13.5031614 L2.22182541,16.363961 L3.63603897,17.7781746 L6.49683865,16.0616948 C7.02216933,16.3659485 7.5907092,16.6038717 8.19100199,16.7640079 L9,20 L11,20 L11.808998,16.7640079 C12.4092908,16.6038717 12.9778307,16.3659485 13.5031614,16.0616948 L16.363961,17.7781746 L17.7781746,16.363961 L16.0616948,13.5031614 C16.3659485,12.9778307 16.6038717,12.4092908 16.7640079,11.808998 L20,11 L20,9 L16.7640079,8.19100199 C16.6038717,7.5907092 16.3659485,7.02216933 16.0616948,6.49683865 L17.7781746,3.63603897 L16.363961,2.22182541 L13.5031614,3.93830521 C12.9778307,3.63405147 12.4092908,3.39612833 11.808998,3.23599205 L11,0 L9,0 L8.19100199,3.23599205 C7.5907092,3.39612833 7.02216933,3.63405147 6.49683865,3.93830521 L3.63603897,2.22182541 L2.22182541,3.63603897 L3.93830521,6.49683865 L3.93830521,6.49683865 Z M10,13 C11.6568542,13 13,11.6568542 13,10 C13,8.34314575 11.6568542,7 10,7 C8.34314575,7 7,8.34314575 7,10 C7,11.6568542 8.34314575,13 10,13 L10,13 Z"
          id="Combined-Shape"
        />
      );
    case "volume":
      return (
        <g>
          <path d="M5 7H1v6h4l5 5V2L5 7zm11.36 9.36l-1.41-1.41a6.98 6.98 0 0 0 0-9.9l1.41-1.41a8.97 8.97 0 0 1 0 12.72zm-2.82-2.82l-1.42-1.42a3 3 0 0 0 0-4.24l1.42-1.42a4.98 4.98 0 0 1 0 7.08z" />
        </g>
      );
    case "muted":
      return (
        <g>
          <path d="M9 7H5v6h4l5 5V2L9 7z" />
        </g>
      );
    case "document":
      return (
        <g>
          <path d="M4 18h12V6h-4V2H4v16zm-2 1V0h12l4 4v16H2v-1z" />
        </g>
      );
    case "logout":
      return (
        <path
          d="M9.8,2c0.3-0.1,0.6,0,0.9,0.2C10.9,2.4,11,2.7,11,3v15H0.5c-0.1,0-0.3,0-0.4-0.1S0,17.6,0,17.5v-1c0-0.1,0-0.3,0.1-0.4
        S0.4,16,0.5,16H3V4.6C3,4.4,3.1,4.2,3.2,4s0.3-0.3,0.5-0.4L9.8,2z M7.7,10.7C7.9,10.9,8,11,8.2,11s0.4-0.1,0.5-0.3
        C8.9,10.5,9,10.3,9,10c0-0.3-0.1-0.5-0.2-0.7C8.6,9.1,8.5,9,8.2,9S7.9,9.1,7.7,9.3C7.6,9.5,7.5,9.7,7.5,10
        C7.5,10.3,7.6,10.5,7.7,10.7z M19.5,16c0.1,0,0.3,0,0.4,0.1s0.1,0.2,0.1,0.4v1c0,0.1,0,0.3-0.1,0.4S19.6,18,19.5,18H15V6h-3V4h3.5
        c0.4,0,0.8,0.2,1.1,0.5S17,5.1,17,5.5V16H19.5z"
        />
      );
    case "edit":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M2,4 L2,18 L16,18 L16,12 L18,10 L18,20 L17,20 L0,20 L0,19 L0,3 L0,2 L10,2 L8,4 L2,4 Z M12.2928932,3.70710678 L4,12 L4,16 L8,16 L16.2928932,7.70710678 L12.2928932,3.70710678 Z M13.7071068,2.29289322 L16,0 L20,4 L17.7071068,6.29289322 L13.7071068,2.29289322 Z" />
        </g>
      );
    case "login":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M11,14.7324356 C11.5978014,14.3866262 12,13.7402824 12,13 C12,11.8954305 11.1045695,11 10,11 C8.8954305,11 8,11.8954305 8,13 C8,13.7402824 8.40219863,14.3866262 9,14.7324356 L9,17 L11,17 L11,14.7324356 Z M13,6 C13,4.34314575 11.6568542,3 10,3 C8.34314575,3 7,4.34314575 7,6 L7,8 L13,8 L13,6 Z M4,8 L4,6 C4,2.6862915 6.6862915,0 10,0 C13.3137085,0 16,2.6862915 16,6 L16,8 L17.0049107,8 C18.1067681,8 19,8.90195036 19,10.0085302 L19,17.9914698 C19,19.1007504 18.1073772,20 17.0049107,20 L2.99508929,20 C1.8932319,20 1,19.0980496 1,17.9914698 L1,10.0085302 C1,8.8992496 1.8926228,8 2.99508929,8 L4,8 Z" />
        </g>
      );
    case "updated":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M2,4 L2,18 L16,18 L16,12 L18,10 L18,20 L17,20 L0,20 L0,19 L0,3 L0,2 L10,2 L8,4 L2,4 Z M12.2928932,3.70710678 L4,12 L4,16 L8,16 L16.2928932,7.70710678 L12.2928932,3.70710678 Z M13.7071068,2.29289322 L16,0 L20,4 L17.7071068,6.29289322 L13.7071068,2.29289322 Z" />
        </g>
      );
    case "trophy":
      return (
        <g>
          <path d="M15 9a3 3 0 0 0 3-3h2a5 5 0 0 1-5.1 5 5 5 0 0 1-3.9 3.9V17l5 2v1H4v-1l5-2v-2.1A5 5 0 0 1 5.1 11H5a5 5 0 0 1-5-5h2a3 3 0 0 0 3 3V4H2v2H0V2h5V0h10v2h5v4h-2V4h-3v5z" />
        </g>
      );
    case "created":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M11,9 L11,5 L9,5 L9,9 L5,9 L5,11 L9,11 L9,15 L11,15 L11,11 L15,11 L15,9 L11,9 Z M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z" />
        </g>
      );
    case "check":
      return <polygon id="Path-126" points="0 11 2 9 7 14 18 3 20 5 7 18" />;
    case "teacher":
      return (
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <path d="M3.33333333,8 L10,12 L20,6 L10,0 L-5.55111512e-16,6 L10,6 L10,6.5 L10,8 L3.33333333,8 L3.33333333,8 Z M1.33226763e-15,8 L1.33226763e-15,16 L2,13.7777778 L2,9.2 L2,9.2 L1.33226763e-15,8 L1.11022302e-16,8 L1.33226763e-15,8 Z M10,20 L5,16.9999998 L3,15.8 L3,9.8 L10,14 L17,9.8 L17,15.8 L10,20 L10,20 Z" />
        </g>
      );
    case "screen-full":
      return (
        <g>
          <path d="M2.8 15.8L0 13v7h7l-2.8-2.8 4.34-4.32-1.42-1.42L2.8 15.8zM17.2 4.2L20 7V0h-7l2.8 2.8-4.34 4.32 1.42 1.42L17.2 4.2zm-1.4 13L13 20h7v-7l-2.8 2.8-4.32-4.34-1.42 1.42 4.33 4.33zM4.2 2.8L7 0H0v7l2.8-2.8 4.32 4.34 1.42-1.42L4.2 2.8z" />
        </g>
      );
    case "link":
      return (
        <g>
          <path d="M9.26 13a2 2 0 0 1 .01-2.01A3 3 0 0 0 9 5H5a3 3 0 0 0 0 6h.08a6.06 6.06 0 0 0 0 2H5A5 5 0 0 1 5 3h4a5 5 0 0 1 .26 10zm1.48-6a2 2 0 0 1-.01 2.01A3 3 0 0 0 11 15h4a3 3 0 0 0 0-6h-.08a6.06 6.06 0 0 0 0-2H15a5 5 0 0 1 0 10h-4a5 5 0 0 1-.26-10z" />
        </g>
      );
    case "convert":
      return (
        <path
          d="M10,16.9c1.6,0,3-0.5,4.3-1.5s2-2.3,2.4-3.8c0.1-0.2,0.2-0.4,0.5-0.4h1.9c0.2,0,0.3,0.1,0.4,0.2s0.1,0.2,0.1,0.4
        c-0.3,1.5-0.9,2.8-1.8,4s-2,2.1-3.4,2.8s-2.8,1-4.4,1c-1.5,0-2.8-0.3-4.1-0.9s-2.4-1.4-3.3-2.5l0.2,3.2c0,0.2,0,0.3-0.1,0.4
        S2.5,20,2.3,20H0.5C0.2,20,0,19.8,0,19.5v-7.8c0-0.1,0-0.2,0.1-0.3s0.2-0.1,0.3-0.1h7.8c0.1,0,0.2,0,0.3,0.1s0.1,0.2,0.1,0.3v1.8
        c0,0.1,0,0.2-0.1,0.3S8.4,14,8.3,14l-4-0.2c0.6,0.9,1.4,1.7,2.4,2.2S8.8,16.9,10,16.9z M17.2,0.5c0-0.2,0-0.3,0.1-0.4
        S17.6,0,17.7,0h1.8c0.1,0,0.2,0,0.3,0.1S20,0.3,20,0.5v7.8c0,0.1,0,0.2-0.1,0.3s-0.2,0.1-0.3,0.1h-7.8c-0.1,0-0.2,0-0.3-0.1
        s-0.1-0.2-0.1-0.3V6.4c0-0.1,0-0.2,0.1-0.3S11.6,6,11.8,6l3.9,0.2c-0.6-0.9-1.4-1.7-2.4-2.2S11.2,3.1,10,3.1c-1.6,0-3,0.5-4.3,1.5
        s-2,2.3-2.4,3.8C3.3,8.6,3.1,8.8,2.9,8.8H0.9c-0.1,0-0.2,0-0.3-0.1S0.5,8.5,0.5,8.5c0-0.1,0-0.2,0-0.3C0.9,5.9,2,4.1,3.8,2.6
        S7.7,0.3,10,0.3c1.5,0,2.8,0.3,4.1,0.9s2.4,1.4,3.3,2.5L17.2,0.5z"
        />
      );
    case "dropdown":
      return (
        <g>
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </g>
      );
    case "quiz":
      return (
        <g>
          <path d="M2 4v14h14v-6l2-2v10H0V2h10L8 4H2zm10.3-.3l4 4L8 16H4v-4l8.3-8.3zm1.4-1.4L16 0l4 4-2.3 2.3-4-4z" />
        </g>
      );
    case "download":
      return (
        <g>
          <path d="M13,10 L13,2 L7,2 L7,10 L2,10 L10,18 L18,10 L13,10 Z" />
        </g>
      );
    case "badge":
      return (
        <g>
          <path
            d="M10,12 C13.3137085,12 16,9.3137085 16,6 C16,2.6862915 13.3137085,0 10,0 C6.6862915,0 4,2.6862915 4,6 C4,9.3137085 6.6862915,12 10,12 Z M10,9 C11.6568542,9 13,7.65685425 13,6 C13,4.34314575 11.6568542,3 10,3 C8.34314575,3 7,4.34314575 7,6 C7,7.65685425 8.34314575,9 10,9 Z M14,11.7453107 L14,20 L10,16 L6,20 L6,11.7453107 C7.13383348,12.5361852 8.51275186,13 10,13 C11.4872481,13 12.8661665,12.5361852 14,11.7453107 L14,11.7453107 Z"
            id="Combined-Shape"
          />
        </g>
      );
    case "ball":
      return (
        <path
          d="M7.5,4.1C5.8,4.9,4.4,5.9,3.1,7.3s-2.2,2.8-2.9,4.5C-0.2,9.6,0.1,7.6,1,5.6s2.4-3.4,4.2-4.4C6.2,2.1,6.9,3,7.5,4.1z M9,9.5
        c-3,1.9-4.9,4.4-5.9,7.8c-1-0.9-1.8-2-2.3-3.3c0.5-1.9,1.3-3.6,2.6-5.1s2.8-2.7,4.7-3.6C8.7,6.6,9,8,9,9.5z M6.1,15.1
        c3.2,2.2,6.6,3,10.4,2.5c-1.9,1.6-4,2.4-6.4,2.4c-1.9,0-3.6-0.5-5.2-1.5C5.1,17.3,5.5,16.1,6.1,15.1z M10,11.1
        c2,1.1,4.2,1.6,6.4,1.6c1,0,2.1-0.1,3.3-0.4c-0.3,1.3-0.9,2.5-1.7,3.6c-1.9,0.5-3.8,0.6-5.8,0.3c-2-0.3-3.8-1.1-5.4-2.2
        C7.7,12.9,8.8,11.9,10,11.1z M15.1,10.7c-1.5-0.2-2.8-0.6-4.1-1.3c-0.1-3.5-1.4-6.5-3.7-9C8.5,0,9.8-0.1,11.1,0.1
        c1.4,1.3,2.5,2.9,3.2,4.8S15.2,8.7,15.1,10.7z M13.4,0.6c1.3,0.5,2.4,1.1,3.4,2.1s1.8,2,2.4,3.3c0.6,1.3,0.8,2.6,0.8,4
        c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c-1.2,0.4-2.4,0.6-3.6,0.6c0.2-1.9,0-3.7-0.5-5.4C15.3,3.6,14.5,2,13.4,0.6z"
        />
      );
    case "calculator":
      return (
        <path
          d="M16.9,0c0.5,0,0.9,0.2,1.3,0.6s0.6,0.8,0.6,1.3v16.2c0,0.5-0.2,0.9-0.6,1.3S17.4,20,16.9,20H3.1c-0.5,0-0.9-0.2-1.3-0.6
        s-0.6-0.8-0.6-1.3V1.9c0-0.5,0.2-0.9,0.6-1.3S2.6,0,3.1,0H16.9z M16.2,7V3c0-0.1-0.1-0.2-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2H4.3
        C4.1,2.5,4,2.6,3.9,2.7C3.8,2.8,3.8,2.9,3.8,3v4c0,0.1,0.1,0.2,0.2,0.4C4,7.4,4.1,7.5,4.3,7.5h11.5c0.1,0,0.2-0.1,0.4-0.2
        C16.2,7.2,16.2,7.1,16.2,7z M6.2,12v-1.5c0-0.1-0.1-0.2-0.2-0.4S5.9,10,5.7,10H4.3c-0.1,0-0.2,0.1-0.4,0.2
        c-0.1,0.1-0.2,0.2-0.2,0.4V12c0,0.1,0.1,0.2,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2h1.5c0.1,0,0.2-0.1,0.4-0.2S6.2,12.1,6.2,12z M6.2,17
        v-1.5c0-0.1-0.1-0.2-0.2-0.4S5.9,15,5.7,15H4.3c-0.1,0-0.2,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.2,0.4V17c0,0.1,0.1,0.2,0.2,0.4
        c0.1,0.1,0.2,0.2,0.4,0.2h1.5c0.1,0,0.2-0.1,0.4-0.2S6.2,17.1,6.2,17z M11.2,12v-1.5c0-0.1-0.1-0.2-0.2-0.4S10.9,10,10.7,10H9.3
        c-0.1,0-0.2,0.1-0.4,0.2s-0.2,0.2-0.2,0.4V12c0,0.1,0.1,0.2,0.2,0.4s0.2,0.2,0.4,0.2h1.5c0.1,0,0.2-0.1,0.4-0.2S11.2,12.1,11.2,12z
         M11.2,17v-1.5c0-0.1-0.1-0.2-0.2-0.4S10.9,15,10.7,15H9.3c-0.1,0-0.2,0.1-0.4,0.2s-0.2,0.2-0.2,0.4V17c0,0.1,0.1,0.2,0.2,0.4
        s0.2,0.2,0.4,0.2h1.5c0.1,0,0.2-0.1,0.4-0.2S11.2,17.1,11.2,17z M16.2,17v-6.5c0-0.1-0.1-0.2-0.2-0.4C16,10.1,15.9,10,15.7,10h-1.5
        c-0.1,0-0.2,0.1-0.4,0.2s-0.2,0.2-0.2,0.4V17c0,0.1,0.1,0.2,0.2,0.4s0.2,0.2,0.4,0.2h1.5c0.1,0,0.2-0.1,0.4-0.2
        C16.2,17.2,16.2,17.1,16.2,17z"
        />
      );
    case "camera":
      return (
        <path
          d="M1.9,1.2h16.2c0.5,0,1,0.2,1.3,0.5S20,2.6,20,3.1v13.8c0,0.5-0.2,1-0.5,1.3s-0.8,0.5-1.3,0.5H1.9c-0.5,0-1-0.2-1.3-0.5
        S0,17.4,0,16.9V3.1c0-0.5,0.2-1,0.5-1.3S1.4,1.2,1.9,1.2z M18.5,6.2c0.2,0,0.2-0.1,0.2-0.2V3.1c0-0.2-0.1-0.3-0.2-0.4
        s-0.3-0.2-0.4-0.2H8.2c-0.1,0-0.1,0-0.2,0.1L6.9,4.4H1.5c-0.2,0-0.2,0.1-0.2,0.2V6c0,0.2,0.1,0.2,0.2,0.2H18.5z M1.9,2.5
        c-0.2,0-0.3,0.1-0.4,0.2S1.2,2.9,1.2,3.1v0.4c0,0.2,0.1,0.2,0.2,0.2H6c0.2,0,0.2-0.1,0.2-0.2V2.7c0-0.2-0.1-0.2-0.2-0.2H1.9z
         M6.7,15.2c0.9,0.9,2,1.4,3.3,1.4s2.4-0.5,3.3-1.4c0.9-0.9,1.4-2,1.4-3.3s-0.5-2.4-1.4-3.3s-2-1.4-3.3-1.4S7.6,7.6,6.7,8.6
        s-1.4,2-1.4,3.3S5.8,14.3,6.7,15.2z M7.6,9.5c0.7-0.7,1.5-1,2.4-1s1.7,0.3,2.4,1s1,1.5,1,2.4s-0.3,1.7-1,2.4s-1.5,1-2.4,1
        s-1.7-0.3-2.4-1s-1-1.5-1-2.4S6.9,10.1,7.6,9.5z M7.7,12.3c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2s0.2-0.3,0.2-0.4
        c0-0.3,0.1-0.6,0.4-0.9s0.5-0.4,0.9-0.4c0.2,0,0.3-0.1,0.4-0.2s0.2-0.3,0.2-0.4s-0.1-0.3-0.2-0.4S10.2,9.4,10,9.4
        c-0.7,0-1.3,0.2-1.8,0.7s-0.7,1.1-0.7,1.8C7.5,12.1,7.6,12.2,7.7,12.3z"
        />
      );
    case "orders":
      return (
        <path
          d="M0,14V6h3v7c0,0.3-0.1,0.5-0.3,0.7C2.5,13.9,2.3,14,2,14H0z M1.9,12.1C1.8,12,1.6,12,1.5,12s-0.3,0-0.4,0.1S1,12.3,1,12.5
        c0,0.1,0,0.3,0.1,0.4S1.4,13,1.5,13s0.3,0,0.4-0.1S2,12.6,2,12.5C2,12.3,2,12.2,1.9,12.1z M15.1,12.6c0.2,0.2,0.3,0.4,0.4,0.7
        c0,0.3,0,0.5-0.2,0.8L15,14.4c-0.2,0.2-0.4,0.3-0.7,0.4s-0.5,0-0.7-0.2l-0.2-0.1l-1,1.2C12.2,15.8,12,16,11.6,16
        c-0.3,0-0.6,0-0.9-0.2l-0.6-0.5c-0.4,0.4-0.8,0.7-1.4,0.8c-0.6,0.1-1-0.1-1.5-0.4L4.6,13H4V6l1.7-1.7C5.9,4.1,6.1,4,6.4,4H9
        L6.5,6.3C6,6.8,5.8,7.3,5.8,7.9s0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.7,1.5,0.7s1.2-0.2,1.6-0.6l0.9-0.8L15.1,12.6z M13.6,4
        c0.3,0,0.5,0.1,0.7,0.3L16,6v6.1c-0.1-0.1-0.2-0.2-0.2-0.2l-4.6-3.7L12,7.4c0.2-0.2,0.3-0.5,0.1-0.7c-0.1-0.1-0.2-0.2-0.4-0.2
        s-0.3,0-0.4,0.1L8.8,8.9v0C8.6,9.1,8.3,9.2,7.9,9.2c-0.4,0-0.6-0.1-0.8-0.4C6.9,8.6,6.8,8.3,6.8,7.9s0.1-0.6,0.4-0.9v0l3.1-2.8
        C10.4,4.1,10.6,4,10.9,4H13.6z M17,6h3v8h-2c-0.3,0-0.5-0.1-0.7-0.3C17.1,13.5,17,13.3,17,13V6z M18.1,12.9
        c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1s0.1-0.2,0.1-0.4c0-0.1,0-0.3-0.1-0.4S18.6,12,18.5,12s-0.3,0-0.4,0.1S18,12.3,18,12.5
        C18,12.6,18,12.8,18.1,12.9z"
        />
      );
    case "stock":
      return (
        <path
          d="M19.1,9.8c0.6,0.2,0.9,0.7,0.9,1.3v4.3c0,0.6-0.3,1-0.8,1.2l-3.9,2c-0.4,0.2-0.8,0.2-1.2,0l-4.1-2l-4.1,2
        c-0.4,0.2-0.8,0.2-1.2,0l-3.9-2C0.3,16.4,0,16,0,15.4v-4.3c0-0.7,0.3-1.1,0.9-1.3l3.8-1.4V4.2c0-0.7,0.3-1.1,0.9-1.3l3.9-1.5
        c0.3-0.1,0.7-0.1,1,0l3.9,1.5c0.6,0.2,0.9,0.7,0.9,1.3v4.2L19.1,9.8z M9.3,11.1l-4-1.5l-4,1.5l4,1.6L9.3,11.1z M9.3,15.4v-2.9L6,14
        v3.1L9.3,15.4z M6,4.1L6,4.1l4,1.6l4-1.6v0l-4-1.5L6,4.1z M14,8.4V5.6L10.7,7v2.7L14,8.4z M18.7,11.1l-4-1.5l-4,1.5l4,1.6
        L18.7,11.1z M18.7,15.4v-2.9L15.4,14v3.1L18.7,15.4z"
        />
      );
    case "back":
      return (
        <g>
          <path d="M57.892,167.913l127.1,-127c9.4,-9.4 9.4,-24.6 0,-33.9c-9.4,-9.4 -24.6,-9.3 -34,0l-144,143.9c-9.1,9.1 -9.3,23.7 -0.7,33.1l144.6,144.9c4.7,4.7 10.9,7 17,7c6.1,0 12.3,-2.3 17,-7c9.4,-9.4 9.4,-24.6 0,-33.9l-127,-127.1Z" />
        </g>
      );

    case "cheveron-right":
      return (
        <polygon points="12.9497475 10.7071068 13.6568542 10 8 4.34314575 6.58578644 5.75735931 10.8284271 10 6.58578644 14.2426407 8 15.6568542 12.9497475 10.7071068" />
      );

    case "feedback":
      return (
        <path
          d="M12.3,3.9c1.4,1.1,2.1,2.4,2.1,3.9s-0.7,2.8-2.1,3.9s-3.1,1.6-5.1,1.6c-1.4,0-2.7-0.3-3.9-0.9c-1,0.6-2,0.9-3.1,0.9
        c0,0-0.1,0-0.1-0.1S0.1,13.2,0,13.2c0-0.1,0-0.2,0-0.3C0.6,12.4,1,11.8,1.3,11C0.4,10,0,9,0,7.8c0-1.5,0.7-2.8,2.1-3.9
        s3.1-1.6,5.1-1.6S10.9,2.8,12.3,3.9z M18.7,15.4c0.3,0.8,0.8,1.4,1.2,1.9c0.1,0.1,0.1,0.2,0,0.3c0,0.1-0.1,0.2-0.2,0.2
        c-1.1,0-2.1-0.3-3.1-0.9c-1.2,0.6-2.5,0.9-3.9,0.9c-1.5,0-2.8-0.3-4-0.9s-2.1-1.4-2.6-2.5c0.4,0,0.8,0.1,1.1,0.1
        c2.3,0,4.3-0.7,5.9-2s2.4-2.9,2.4-4.7c0-0.3,0-0.5,0-0.7c1.3,0.4,2.4,1.1,3.2,2s1.2,2,1.2,3.1C20,13.4,19.6,14.5,18.7,15.4z"
        />
      );
    case "star":
      return (
        <polygon points="10 15 4.12214748 18.0901699 5.24471742 11.545085 0.489434837 6.90983006 7.06107374 5.95491503 10 0 12.9389263 5.95491503 19.5105652 6.90983006 14.7552826 11.545085 15.8778525 18.0901699" />
      );
    case "youtube":
      return (
        <g>
          <path
            stroke="null"
            fillRule="evenodd"
            clipRule="evenodd"
            d="m13.167761,12.440576c-0.092436,0 -0.158937,0.025935 -0.199502,0.081131c-0.040233,0.051871 -0.059851,0.140982 -0.059851,0.264673l0,0.297923l0.513053,0l0,-0.297923c0,-0.123691 -0.020615,-0.212802 -0.061513,-0.264673c-0.03857,-0.055196 -0.104074,-0.081131 -0.192187,-0.081131zm-2.001006,-0.010308c0.077806,0 0.138654,0.02527 0.180882,0.076476c0.040898,0.051206 0.061513,0.127349 0.061513,0.226767l0,1.524196c0,0.095096 -0.017623,0.161929 -0.050873,0.20316c-0.03325,0.042228 -0.085121,0.062843 -0.156277,0.062843c-0.049211,0 -0.095429,-0.010973 -0.139984,-0.03192c-0.044888,-0.020615 -0.091106,-0.056858 -0.137989,-0.104074l0,-1.839077c0.039568,-0.040565 0.079468,-0.070823 0.119701,-0.090108c0.040233,-0.019618 0.081131,-0.028263 0.123026,-0.028263zm1.741986,1.113554l0,0.555946c0,0.155612 0.018953,0.263343 0.056526,0.323858c0.039235,0.060183 0.104074,0.089443 0.196842,0.089443c0.096094,0 0.163259,-0.02527 0.201497,-0.076143c0.037905,-0.050873 0.058188,-0.162594 0.058188,-0.336826l0,-0.134664l0.596844,0l0,0.151622c0,0.302911 -0.072153,0.530676 -0.218455,0.684625c-0.144639,0.152619 -0.362096,0.22843 -0.651042,0.22843c-0.259685,0 -0.46484,-0.080466 -0.614134,-0.24306c-0.148962,-0.161597 -0.224772,-0.384707 -0.224772,-0.669662l0,-1.325359c0,-0.255363 0.082793,-0.46484 0.246718,-0.625772c0.163924,-0.161264 0.375064,-0.24173 0.635414,-0.24173c0.26567,0 0.469828,0.074813 0.612804,0.224107c0.142644,0.148962 0.213467,0.363426 0.213467,0.643394l0,0.752788l-1.109897,0l0,-0.000998zm-1.039074,1.275816c-0.090108,0.111721 -0.222445,0.166584 -0.394682,0.166584c-0.114049,0 -0.214797,-0.020615 -0.303243,-0.063841c-0.088778,-0.042893 -0.172569,-0.108729 -0.248048,-0.199835l0,0.226435l-0.586536,0l0,-4.000683l0.586536,0l0,1.288451c0.078803,-0.089776 0.161264,-0.158937 0.248713,-0.205155c0.088778,-0.047216 0.177557,-0.070158 0.267665,-0.070158c0.184207,0 0.324191,0.062843 0.420617,0.187865c0.097756,0.126019 0.145637,0.310226 0.145637,0.551956l0,1.637912c0,0.208812 -0.045553,0.368746 -0.136659,0.480468zm-2.54864,0.129344l0,-0.324523c-0.108064,0.120034 -0.218787,0.211472 -0.335496,0.273318c-0.116044,0.063508 -0.228097,0.093766 -0.337159,0.093766c-0.134664,0 -0.234415,-0.042893 -0.303576,-0.131671c-0.066833,-0.088446 -0.101414,-0.218787 -0.101414,-0.395347l0,-2.467841l0.579886,0l0,2.264017c0,0.070158 0.012303,0.120366 0.035578,0.151954c0.025603,0.031588 0.065171,0.046883 0.119036,0.046883c0.04256,0 0.097091,-0.020615 0.162262,-0.062511c0.065503,-0.041563 0.124689,-0.094099 0.180217,-0.157939l0,-2.242404l0.579886,0l0,2.951967l-0.579221,0l0,0.000333zm-2.008986,-3.419467l0,3.419467l-0.654367,0l0,-3.419467l-0.676312,0l0,-0.581216l2.006991,0l0,0.581216l-0.676312,0zm2.685964,-1.869335c0,-0.000333 4.016643,0.005985 4.493453,0.48213c0.478473,0.477143 0.483793,2.830935 0.483793,2.844568c0,0 -0.00399,2.366428 -0.483793,2.8449c-0.47681,0.47548 -4.493453,0.485788 -4.493453,0.485788s-4.01631,-0.010308 -4.494118,-0.48612c-0.47814,-0.477143 -0.479138,-2.826945 -0.479138,-2.8449c0,-0.013633 0.00133,-2.367425 0.479138,-2.844568c0.47814,-0.475813 4.494118,-0.48213 4.494118,-0.481798zm3.167429,-1.237911l-0.653702,0l0,-0.359104c-0.119036,0.132004 -0.244723,0.23375 -0.375729,0.302246c-0.130341,0.069161 -0.25636,0.103741 -0.379054,0.103741c-0.152287,0 -0.265005,-0.048546 -0.341481,-0.145304c-0.076143,-0.096759 -0.114714,-0.24173 -0.114714,-0.435912l0,-2.717219l0.652372,0l0,2.492779c0,0.076808 0.014963,0.132669 0.042228,0.166917c0.0266,0.03458 0.071821,0.051871 0.132669,0.051871c0.047548,0 0.108729,-0.022943 0.182212,-0.068496c0.073151,-0.045553 0.140649,-0.103741 0.201165,-0.175229l0,-2.467841l0.653702,0l0,3.251552l0.000333,0zm-3.54881,-0.554283c0.046218,0.048878 0.112719,0.072818 0.199502,0.072818c0.088446,0 0.158272,-0.024938 0.210807,-0.074148c0.052203,-0.050541 0.078138,-0.119036 0.078138,-0.205487l0,-1.771246c0,-0.071156 -0.0266,-0.128679 -0.080133,-0.172569c-0.053201,-0.043558 -0.123026,-0.065171 -0.208812,-0.065171c-0.080133,0 -0.144639,0.021613 -0.194847,0.065171c-0.049211,0.04389 -0.074813,0.101414 -0.074813,0.172569l0,1.771246c0,0.088778 0.02394,0.157274 0.070158,0.206817zm-0.478473,-2.55529c0.175562,-0.149294 0.412637,-0.224107 0.708898,-0.224107c0.269993,0 0.492105,0.078803 0.66534,0.23641c0.171904,0.157274 0.258355,0.360101 0.258355,0.607816l0,1.679475c0,0.277973 -0.084788,0.495763 -0.253368,0.654367c-0.170574,0.158272 -0.402994,0.237408 -0.700252,0.237408c-0.285288,0 -0.514383,-0.081796 -0.686287,-0.244723c-0.170574,-0.163592 -0.256693,-0.383377 -0.256693,-0.659687l0,-1.685128c-0.000333,-0.25237 0.087448,-0.45287 0.264008,-0.601831zm-2.043567,-1.297761l-0.74115,0l0.875814,2.661026l0,1.746309l0.73583,0l0,-1.82877l0.855864,-2.578565l-0.748133,0l-0.4542,1.761604l-0.046218,0l-0.477808,-1.761604zm2.905416,15.96017c-5.508919,0 -9.975107,-4.466188 -9.975107,-9.975107c0,-5.509251 4.466188,-9.975107 9.975107,-9.975107s9.975107,4.465855 9.975107,9.975107c0,5.508919 -4.466188,9.975107 -9.975107,9.975107z"
          />
        </g>
      );
    case "factory":
      return (
        <path
          d="M19.2,8c0.2,0,0.4,0.1,0.5,0.2S20,8.5,20,8.8V17c0,0.3-0.1,0.5-0.3,0.7S19.3,18,19,18H1c-0.3,0-0.5-0.1-0.7-0.3
        S0,17.3,0,17V5.8c0-0.2,0.1-0.4,0.2-0.5S0.5,5,0.8,5H2V2.5c0-0.1,0-0.3,0.1-0.4S2.4,2,2.5,2H3c0.1,0,0.3,0,0.4,0.1s0.1,0.2,0.1,0.4
        V5h2V2.5c0-0.1,0-0.3,0.1-0.4S5.9,2,6,2h0.5c0.1,0,0.3,0,0.4,0.1S7,2.4,7,2.5V5h2V2.8c0-0.2,0.1-0.4,0.2-0.5S9.5,2,9.8,2h4.5
        c0.2,0,0.4,0.1,0.5,0.2S15,2.5,15,2.8V8H19.2z M4,8.6V7.4C4,7.1,3.9,7,3.6,7H2.4C2.1,7,2,7.1,2,7.4v1.2C2,8.9,2.1,9,2.4,9h1.2
        C3.9,9,4,8.9,4,8.6z M4,11.6v-1.2C4,10.1,3.9,10,3.6,10H2.4C2.1,10,2,10.1,2,10.4v1.2C2,11.9,2.1,12,2.4,12h1.2
        C3.9,12,4,11.9,4,11.6z M4,14.6v-1.2C4,13.1,3.9,13,3.6,13H2.4C2.1,13,2,13.1,2,13.4v1.2C2,14.9,2.1,15,2.4,15h1.2
        C3.9,15,4,14.9,4,14.6z M8,8.6V7.4C8,7.1,7.9,7,7.6,7H6.4C6.1,7,6,7.1,6,7.4v1.2C6,8.9,6.1,9,6.4,9h1.2C7.9,9,8,8.9,8,8.6z M8,11.6
        v-1.2C8,10.1,7.9,10,7.6,10H6.4C6.1,10,6,10.1,6,10.4v1.2C6,11.9,6.1,12,6.4,12h1.2C7.9,12,8,11.9,8,11.6z M8,14.6v-1.2
        C8,13.1,7.9,13,7.6,13H6.4C6.1,13,6,13.1,6,13.4v1.2C6,14.9,6.1,15,6.4,15h1.2C7.9,15,8,14.9,8,14.6z M13,5.6V4.4
        C13,4.1,12.9,4,12.6,4h-1.2C11.1,4,11,4.1,11,4.4v1.2C11,5.9,11.1,6,11.4,6h1.2C12.9,6,13,5.9,13,5.6z M13,8.6V7.4
        C13,7.1,12.9,7,12.6,7h-1.2C11.1,7,11,7.1,11,7.4v1.2C11,8.9,11.1,9,11.4,9h1.2C12.9,9,13,8.9,13,8.6z M13,11.6v-1.2
        c0-0.2-0.1-0.4-0.4-0.4h-1.2c-0.2,0-0.4,0.1-0.4,0.4v1.2c0,0.2,0.1,0.4,0.4,0.4h1.2C12.9,12,13,11.9,13,11.6z M18,11.6v-1.2
        c0-0.2-0.1-0.4-0.4-0.4h-1.2c-0.2,0-0.4,0.1-0.4,0.4v1.2c0,0.2,0.1,0.4,0.4,0.4h1.2C17.9,12,18,11.9,18,11.6z M18,14.6v-1.2
        c0-0.2-0.1-0.4-0.4-0.4h-1.2c-0.2,0-0.4,0.1-0.4,0.4v1.2c0,0.2,0.1,0.4,0.4,0.4h1.2C17.9,15,18,14.9,18,14.6z"
        />
      );
    case "fb":
      return (
        <g>
          <path d="m8.590179,15.432883l2.24506,0l0,-5.43355l1.497705,0l0.198407,-1.872215l-1.696112,0l0.00233,-0.937439c0,-0.488027 0.046606,-0.750018 0.747022,-0.750018l0.936107,0l0,-1.872547l-1.498038,0c-1.79931,0 -2.432481,0.908477 -2.432481,2.43581l0,1.124194l-1.121531,0l0,1.872547l1.121531,0l0,5.433217zm1.40982,4.554036c-5.515443,0 -9.98692,-4.471477 -9.98692,-9.98692c0,-5.515776 4.471477,-9.98692 9.98692,-9.98692s9.98692,4.471144 9.98692,9.98692c0,5.515443 -4.471477,9.98692 -9.98692,9.98692z" />
        </g>
      );
    case "instagram":
      return (
        <g>
          <path d="m13.082603,7.532188l0,-0.001995c0.166915,0 0.334162,0.003325 0.501409,-0.000665c0.214795,-0.00532 0.389689,-0.189525 0.389689,-0.404652c0,-0.320197 0,-0.640727 0,-0.960924c0,-0.229757 -0.181877,-0.412299 -0.410969,-0.412632c-0.319532,0 -0.639064,-0.000332 -0.958596,0c-0.22876,0.000332 -0.410969,0.18354 -0.410969,0.413297c-0.000332,0.317537 -0.00133,0.635074 0.000997,0.952611c0.000332,0.047547 0.00931,0.096757 0.024272,0.141645c0.057522,0.16891 0.212467,0.27265 0.401992,0.273647c0.153947,0 0.308227,-0.000332 0.462174,-0.000332zm-3.082603,0.411967c-1.125179,-0.000665 -2.039885,0.904731 -2.055512,2.02459c-0.016292,1.150448 0.904399,2.06183 2.008297,2.085437c1.148453,0.024605 2.077457,-0.893094 2.10173,-2.009295c0.024937,-1.150448 -0.903401,-2.101397 -2.054515,-2.100732zm-3.9747,1.096916l0,0.027265c0,1.501236 -0.000332,3.002471 0,4.503707c0,0.215792 0.186865,0.401659 0.402989,0.401659c2.380697,0.000332 4.761061,0.000332 7.141758,0c0.21812,0 0.403987,-0.185202 0.403987,-0.402989c0.000332,-1.499241 0,-2.999146 0,-4.498054l0,-0.031255l-0.968239,0c0.136657,0.436904 0.178552,0.881456 0.12502,1.334653c-0.053532,0.453197 -0.199832,0.874806 -0.437569,1.264496s-0.546629,0.713212 -0.924016,0.970234c-0.978879,0.666994 -2.267979,0.725514 -3.307041,0.14231c-0.525017,-0.294262 -0.937316,-0.704899 -1.225261,-1.234571c-0.428592,-0.789021 -0.497087,-1.61761 -0.245717,-2.477454c-0.32186,0 -0.641724,0 -0.965911,0zm8.032857,6.03121c0.052867,-0.008645 0.105735,-0.016292 0.157937,-0.027597c0.414294,-0.088112 0.752779,-0.433579 0.833909,-0.850201c0.008312,-0.045552 0.014962,-0.090772 0.022277,-0.135992l0,-8.116979c-0.006982,-0.044222 -0.0133,-0.08911 -0.021612,-0.133332c-0.08911,-0.454527 -0.464169,-0.807309 -0.924349,-0.870484c-0.019285,-0.002327 -0.037572,-0.00665 -0.056525,-0.009975l-8.139257,0c-0.048877,0.008977 -0.09842,0.015627 -0.146632,0.0266c-0.449539,0.10241 -0.782039,0.464169 -0.846211,0.919694c-0.00266,0.018952 -0.00665,0.037905 -0.009642,0.056857l0,8.138924c0.00931,0.051205 0.016625,0.103407 0.028262,0.154612c0.099417,0.439564 0.474477,0.780376 0.921024,0.837899c0.02128,0.00266 0.043225,0.006982 0.064837,0.009975l8.115982,0zm-4.058157,4.902706c-5.508853,0 -9.974987,-4.466134 -9.974987,-9.974987c0,-5.509185 4.466134,-9.974987 9.974987,-9.974987s9.974987,4.465802 9.974987,9.974987c0,5.508853 -4.466134,9.974987 -9.974987,9.974987z" />
        </g>
      );
    case "twitter":
      return (
        <g>
          <path d="m11.38555,6.104033c-0.870832,0.316878 -1.421129,1.134176 -1.358617,2.028616l0.020948,0.345141l-0.348466,-0.042228c-1.267843,-0.16193 -2.375752,-0.711229 -3.31641,-1.634265l-0.459855,-0.45786l-0.118372,0.338158c-0.250709,0.75379 -0.090441,1.549808 0.431925,2.085142c0.27864,0.29593 0.215796,0.338158 -0.264674,0.16193c-0.16725,-0.056193 -0.313553,-0.098422 -0.327518,-0.077474c-0.048546,0.049543 0.118372,0.690281 0.250709,0.943983c0.181215,0.352456 0.550297,0.697264 0.954623,0.901755l0.341483,0.16193l-0.403994,0.006983c-0.390029,0 -0.403994,0.006983 -0.362098,0.15528c0.13932,0.45786 0.689616,0.943983 1.302757,1.155457l0.431925,0.147632l-0.376064,0.225439c-0.557279,0.324525 -1.212315,0.507403 -1.867351,0.521036c-0.313885,0.006983 -0.571577,0.035246 -0.571577,0.056526c0,0.070159 0.850217,0.46451 1.344652,0.61979c1.483972,0.45786 3.246916,0.260352 4.570621,-0.521369c0.940658,-0.556614 1.880984,-1.662527 2.320223,-2.733528c0.237076,-0.570247 0.47382,-1.612984 0.47382,-2.11274c0,-0.324193 0.020948,-0.366421 0.410977,-0.75379c0.230094,-0.225439 0.44589,-0.471825 0.487786,-0.542316c0.069826,-0.134 0.062511,-0.134 -0.292605,-0.014298c-0.592192,0.211473 -0.675984,0.183211 -0.383046,-0.133667c0.215796,-0.225439 0.47382,-0.634088 0.47382,-0.75379c0,-0.020948 -0.104407,0.013965 -0.223111,0.077474c-0.125355,0.070491 -0.403994,0.176228 -0.61314,0.239404l-0.376064,0.120034l-0.341483,-0.232754c-0.188198,-0.126685 -0.45254,-0.267667 -0.592192,-0.309895c-0.355448,-0.098422 -0.899095,-0.084456 -1.21963,0.028263zm-1.38555,13.871132c-5.508951,0 -9.975165,-4.466214 -9.975165,-9.975165c0,-5.509284 4.466214,-9.975165 9.975165,-9.975165s9.975165,4.465881 9.975165,9.975165c0,5.508951 -4.466214,9.975165 -9.975165,9.975165z" />
        </g>
      );
    case "video":
      return (
        <path d="M0,3.99406028 C0,2.8927712 0.894513756,2 1.99406028,2 L14.0059397,2 C15.1072288,2 16,2.89451376 16,3.99406028 L16,16.0059397 C16,17.1072288 15.1054862,18 14.0059397,18 L1.99406028,18 C0.892771196,18 0,17.1054862 0,16.0059397 L0,3.99406028 Z M8,14 C10.209139,14 12,12.209139 12,10 C12,7.790861 10.209139,6 8,6 C5.790861,6 4,7.790861 4,10 C4,12.209139 5.790861,14 8,14 Z M8,12 C9.1045695,12 10,11.1045695 10,10 C10,8.8954305 9.1045695,8 8,8 C6.8954305,8 6,8.8954305 6,10 C6,11.1045695 6.8954305,12 8,12 Z M16,7 L20,3 L20,17 L16,13 L16,7 Z" />
      );
    case "chart":
      return (
        <path
          d="M19.4,15.6c0.2,0,0.3,0.1,0.4,0.2s0.2,0.3,0.2,0.4v0.6c0,0.2-0.1,0.3-0.2,0.4s-0.3,0.2-0.4,0.2H1.2c-0.3,0-0.6-0.1-0.9-0.4
  S0,16.6,0,16.2V3.1c0-0.2,0.1-0.3,0.2-0.4s0.3-0.2,0.4-0.2h0.6c0.2,0,0.3,0.1,0.4,0.2s0.2,0.3,0.2,0.4v12.5H19.4z M4.3,13.8
  c-0.1,0-0.2-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.4v-2.7c0-0.1,0.1-0.2,0.2-0.4C4,10.1,4.1,10,4.3,10h0.9c0.1,0,0.2,0.1,0.4,0.2
  s0.2,0.2,0.2,0.4v2.7c0,0.1-0.1,0.2-0.2,0.4s-0.2,0.2-0.4,0.2H4.3z M8,13.8c-0.1,0-0.2-0.1-0.4-0.2s-0.2-0.2-0.2-0.4V5.5
  c0-0.1,0.1-0.2,0.2-0.4S7.9,5,8,5h0.9C9,5,9.1,5.1,9.2,5.2s0.2,0.2,0.2,0.4v7.7c0,0.1-0.1,0.2-0.2,0.4S9,13.8,8.9,13.8H8z
   M11.8,13.8c-0.1,0-0.2-0.1-0.4-0.2s-0.2-0.2-0.2-0.4V8c0-0.1,0.1-0.2,0.2-0.4s0.2-0.2,0.4-0.2h0.9c0.1,0,0.2,0.1,0.4,0.2
  s0.2,0.2,0.2,0.4v5.2c0,0.1-0.1,0.2-0.2,0.4s-0.2,0.2-0.4,0.2H11.8z M15.5,13.8c-0.1,0-0.2-0.1-0.4-0.2S15,13.4,15,13.2v-9
  c0-0.1,0.1-0.2,0.2-0.4c0.1-0.1,0.2-0.2,0.4-0.2h0.9c0.1,0,0.2,0.1,0.4,0.2c0.1,0.1,0.2,0.2,0.2,0.4v9c0,0.1-0.1,0.2-0.2,0.4
  s-0.2,0.2-0.4,0.2H15.5z"
        />
      );
    default:
      return (
        <g>
          <path d="M0 4c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm11 9l-3-3-6 6h16l-5-5-2 2zm4-4a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
        </g>
      );
  }
}
